import is from './is.js';
import not from './not.js';
export default function isNot(value) {
    return not(is(value));
}
//# sourceMappingURL=is-not.js.map